import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ValidateCSVAndUploadSpocsRPC } from "./validateCsvAndUploadSpocsRPC";

export class ValidateCSVAndUploadSpocsRPCClientImpl extends ValidateCSVAndUploadSpocsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ValidateCSVAndUploadSpocsRPC.Request): Promise<LeoRPCResult<ValidateCSVAndUploadSpocsRPC.Response, ValidateCSVAndUploadSpocsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/ValidateCSVAndUploadSpocs",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ValidateCSVAndUploadSpocsRPC.ResponseDTO,
      ValidateCSVAndUploadSpocsRPC.Errors.ErrorsDTO,
      ValidateCSVAndUploadSpocsRPC.Response,
      ValidateCSVAndUploadSpocsRPC.Errors.Errors
    >(
      response,
      "spoc-management/ValidateCSVAndUploadSpocs",
      ValidateCSVAndUploadSpocsRPC.Response.fromDTO,
      ValidateCSVAndUploadSpocsRPC.Errors.fromDTO
    );
  }
}
